import { Injectable, inject } from '@angular/core'

import { isNumber } from 'lodash/fp'

import { Observable, map } from 'rxjs'

import { PrivateDocumentsService } from '@flowx/designer/shared/services/documents-private.service'

export function getFilename(newFilename: string, existingFilenames: string[]): string {
  const existingFilename = existingFilenames.find((filename) => filename === newFilename)

  if (existingFilename) {
    const separatorIndex = newFilename.lastIndexOf('.')
    const currName = newFilename.slice(0, separatorIndex)
    const currExt = newFilename.slice(separatorIndex + 1)
    const matchedFilenames = existingFilenames.filter(
      (filename) => filename.startsWith(currName) && filename.endsWith(currExt)
    )

    const matchedIndexes = matchedFilenames
      .map((name) => {
        const separatorIndex = name.lastIndexOf('_')

        if (name.substring(0, separatorIndex) === currName) {
          return parseInt(name.slice(separatorIndex + 1), 10)
        } else {
          return null
        }
      })
      .filter((value) => isNumber(value))
    const lastFilenameIndex = matchedIndexes.length ? Math.max(...matchedIndexes) : null

    return `${currName}_${(lastFilenameIndex ?? 0) + 1}.${currExt}`
  }

  return newFilename
}

@Injectable({ providedIn: 'root' })
export class AiDocumentsFilenameService {
  #privateDocumentsService = inject(PrivateDocumentsService)

  checkFilename(filename: string): Observable<string> {
    const separatorIndex = filename.lastIndexOf('.')
    const currName = filename.slice(0, separatorIndex)

    return this.#privateDocumentsService
      .getDocuments({
        page: 0,
        size: 500,
        filename: currName,
        sort: 'createdDate,desc',
        tab: 'ALL',
      } as unknown)
      .pipe(
        map((documents) => {
          if (documents.content.length === 0) {
            return filename
          } else {
            return getFilename(
              filename,
              documents.content.map(({ filename }) => filename)
            )
          }
        })
      )
  }
}
